import axios from "axios";
import session from '../api/session';
import download from 'downloadjs'
import moment from 'moment';

export class APIService {
  constructor() { }

  buildFilterUrl(total, value,) {
    return total + `&${value[0]}=${value[1]}`;
  }

  //Prisoner
  getPrisoners(sort, search, limit, offset) {
    const url = `/prisoner/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;
    return session.get(url, {}).then(response => response.data);
  }

  searchPrisoners(v) {
    const url = `/prisoner/?search=${v}`;
    return session.get(url, {}).then(response => response.data);
  }

  getPrisoner(id) {
    const url = `/prisoner/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  getPrisonerPermissions(id) {
    const url = `/prisoner/${id}/permissions/`;
    return session.get(url, {}).then(response => response.data);
  }

  deletePrisoner(prisoner) {
    const url = `/prisoner/${prisoner.id}/`;
    return session.delete(url, {});
  }

  createPrisoner(prisoner) {
    const url = `/prisoner/`;
    return session.post(url, prisoner).then(response => response.data);
  }

  updatePrisoner(prisoner) {
    const url = `/prisoner/${prisoner.id}/`;
    return session.put(url, prisoner).then(response => response.data);
  }

  // User
  getUsers(sort, search, limit, offset) {
    const url = `/user/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;
    return session.get(url, {}).then(response => response.data);
  }

  getUsersOwn(sort, search, limit, offset) {
    const url = `/user_own/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;
    return session.get(url, {}).then(response => response.data);
  }

  searchUsers(v) {
    const url = `/user/?search=${v}`;
    return session.get(url, {}).then(response => response.data);
  }

  getUser(id) {
    const url = `/user/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  getUserPermissions(id) {
    const url = `/user/${id}/permissions/`;
    return session.get(url, {}).then(response => response.data);
  }

  deleteUser(user) {
    const url = `/user/${user.id}/`;
    return session.delete(url, {});
  }

  createUser(user) {
    const url = `/user/`;
    return session.post(url, user).then(response => response.data);
  }

  updateUser(user) {
    const url = `/user/${user.id}/`;
    return session.put(url, user).then(response => response.data);
  }

  // Institution
  getInstitutions(sort, search, limit, offset) {
    const url = `/institution/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;
    return session.get(url, {}).then(response => response.data);
  }

  searchInstitutions(v) {
    const url = `/institution/?search=${v}`;
    return session.get(url, {}).then(response => response.data);
  }

  getInstitution(id) {
    const url = `/institution/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  getInstitutionPermissions(id) {
    const url = `/institution/${id}/permissions/`;
    return session.get(url, {}).then(response => response.data);
  }

  deleteInstitution(institution) {
    const url = `/institution/${institution.id}/`;
    return session.delete(url, {});
  }

  createInstitution(institution) {
    const url = `/institution/`;
    return session.post(url, institution).then(response => response.data);
  }

  updateInstitution(institution) {
    const url = `/institution/${institution.id}/`;
    return session.put(url, institution).then(response => response.data);
  }

  // institution admin
  getInstitutionsAdmin(sort, search, limit, offset) {
    const url = `/institution_admin/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;
    return session.get(url, {}).then(response => response.data);
  }

  searchInstitutionsAdmin(v) {
    const url = `/institution_admin/?search=${v}`;
    return session.get(url, {}).then(response => response.data);
  }

  getInstitutionAdmin(id) {
    const url = `/institution_admin/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  getInstitutionPermissionsAdmin(id) {
    const url = `/institution_admin/${id}/permissions/`;
    return session.get(url, {}).then(response => response.data);
  }

  deleteInstitutionAdmin(institution) {
    const url = `/institution_admin/${institution.id}/`;
    return session.delete(url, {});
  }

  createInstitutionAdmin(institution) {
    const url = `/institution_admin/`;
    return session.post(url, institution).then(response => response.data);
  }

  updateInstitutionAdmin(institution) {
    const url = `/institution_admin/${institution.id}/`;
    return session.put(url, institution).then(response => response.data);
  }
  // CRA forms
  getCraForms(sort, search, limit, offset, filter) {
    let url = "";

    if (filter) {
      var filter_url = filter.reduce(this.buildFilterUrl, "");

      url = `/cr_cra/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}${filter_url}`;
    }
    else
      url = `/cr_cra/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;

    return session.get(url, {}).then(response => response.data);
  }

  getCraMultipleForms(sort, search, limit, offset, filter) {
    let url = "";

    if (filter) {
      var filter_url = filter.reduce(this.buildFilterUrl, "");

      url = `/cr_cra_multiple_forms/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}${filter_url}`;
    }
    else
      url = `/cr_cra_multiple_forms/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;

    return session.get(url, {}).then(response => response.data);
  }

  getCraForm(id) {
    const url = `/cr_cra/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  getCraFormPermissions(id) {
    const url = `/cr_cra/${id}/permissions/`;
    return session.get(url, {}).then(response => response.data);
  }

  deleteCraForm(item) {
    const url = `/cr_cra/${item.id}/`;
    return session.delete(url, {});
  }

  createCraForm(item) {
    const url = `/cr_cra/`;
    return session.post(url, item).then(response => response.data);
  }

  updateCraForm(item) {
    const url = `/cr_cra/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  cloneCraForm(id, item) {
    const url = `/cr_cra/${id}/clone/`;
    return session.put(url, item).then(response => response.data);
  }

  // Rizikove faktory
  getRizikoveFaktory(cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/rizikove_faktory/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  deleteRizikoveFaktory(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/rizikove_faktory/${item.id}/`;
    return session.delete(url, {});
  }

  updateRizikoveFaktory(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/rizikove_faktory/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  // Penitenciarne zaobchadzanie
  getPenitenciarneZaobchadzanie(cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/penitenciarne_zaobchadzanie/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  deletePenitenciarneZaobchadzanie(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/penitenciarne_zaobchadzanie/${item.id}/`;
    return session.delete(url, {});
  }

  updatePenitenciarneZaobchadzanie(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/penitenciarne_zaobchadzanie/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  // Psychologicke vysetrenie
  getPsychologickeVysetrenie(cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/psychologicke_vysetrenie/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  deletePsychologickeVysetrenie(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/psychologicke_vysetrenie/${item.id}/`;
    return session.delete(url, {});
  }

  updatePsychologickeVysetrenie(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/psychologicke_vysetrenie/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  // PBS
  getPBS(cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/poznatky_pbs/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  deletePBS(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/poznatky_pbs/${item.id}/`;
    return session.delete(url, {});
  }

  updatePBS(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/poznatky_pbs/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  // Nahodne overenie
  getNahodneOverenie(cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/nahodne_overenie/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  deleteNahodneOverenie(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/nahodne_overenie/${item.id}/`;
    return session.delete(url, {});
  }

  updateNahodneOverenie(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/nahodne_overenie/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  // Socialny kurator
  getSocialnyKurator(cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/socialny_kurator/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  deleteSocialnyKurator(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/socialny_kurator/${item.id}/`;
    return session.delete(url, {});
  }

  updateSocialnyKurator(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/socialny_kurator/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  // Open reason
  createOpenReason(item, cr_cra_id) {
    const url = `/cr_cra/${cr_cra_id}/open_reasons/`;
    return session.post(url, item).then(response => response.data);
  }

  // History
  getCrCraHistory(id) {
    const url = `/cr_cra/${id}/history`;
    return session.get(url, {}).then(response => response.data);
  }

  getInstitutionHistory(id) {
    const url = `/institution/${id}/history`;
    return session.get(url, {}).then(response => response.data);
  }

  getUserHistory(id) {
    const url = `/user/${id}/history`;
    return session.get(url, {}).then(response => response.data);
  }

  getPrisonerHistory(id) {
    const url = `/prisoner/${id}/history`;
    return session.get(url, {}).then(response => response.data);
  }


  getStatistics(date_from, date_to) {
    const url = `/cr_cra/statistics/`;
    return session.get(url, { params: { date_from: date_from, date_to: date_to } }).then(response => response.data);
  }

  getStatisticsGraphs(date_from, date_to) {
    const url = `/cr_cra/statistics_graphs/`;
    return session.get(url, { params: { date_from: date_from, date_to: date_to } }).then(response => response.data);
  }

  getStatisticsGraphsDetails(date_from, date_to) {
    const url = `/cr_cra/statistics_graphs_details/`;
    return session.get(url, { params: { date_from: date_from, date_to: date_to } }).then(response => response.data);
  }


  getCrCraExport() {
    const url = `/cr_cra_export`;
    return session.get(url, { responseType: 'blob' }).then((response) => {
      const content = response.headers['content-type'];
      download(response.data, `export_cra_${moment().format()}.xlsx`, content)
    });
  }

  getIapszExport() {
    const url = `/iapsz_export`;
    return session.get(url, { responseType: 'blob' }).then((response) => {
      const content = response.headers['content-type'];
      download(response.data, `export_iapsz_${moment().format()}.xlsx`, content)
    });
  }


  // IAPSZ Forms
  getIapszForms(sort, search, limit, offset, filter) {
    let url = "";
    if (filter) {
      var filter_url = filter.reduce(this.buildFilterUrl, "");

      url = `/iapsz/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}${filter_url}`;
    }
    else
      url = `/iapsz/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;

    return session.get(url, {}).then(response => response.data);
  }

  getIapszForm(id) {
    const url = `/iapsz/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  getIapszFormPermissions(id) {
    const url = `/iapsz/${id}/permissions/`;
    return session.get(url, {}).then(response => response.data);
  }

  deleteIapszForm(item) {
    const url = `/iapsz/${item.id}/`;
    return session.delete(url, {});
  }

  createIapszForm(item) {
    const url = `/iapsz/`;
    return session.post(url, item).then(response => response.data);
  }

  updateIapszForm(item) {
    const url = `/iapsz/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }


  // IAPSZ
  createIapsz(item) {
    const url = `/iapsz/`;
    return session.post(url, item).then(response => response.data);
  }

  getIapsz(id) {
    const url = `/iapsz/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  getIapszUdajeOKlientovi(id) {
    const url = `/iapsz/${id}/udaje_o_klientovi/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  updateIapszUdajeOKlientovi(item, iapsz_id) {
    const url = `/iapsz/${iapsz_id}/udaje_o_klientovi/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  getIapszPotrebyPlan(id) {
    const url = `/iapsz/${id}/potreby_plan/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  getIapszPotrebyPlanExport(iapsz_id, potreby_plan_id) {
    const url = `/iapsz/${iapsz_id}/potreby_plan/${potreby_plan_id}/download/`
    return session.get(url, { responseType: "blob" }).then(response => response.data);
  }

  updateIapszPotrebyPlan(item, iapsz_id) {
    const url = `/iapsz/${iapsz_id}/potreby_plan/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  getIapszSwot(id) {
    const url = `/iapsz/${id}/swot/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  updateIapszSwot(item, iapsz_id) {
    const url = `/iapsz/${iapsz_id}/swot/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  getIapszAktualnyStav(id) {
    const url = `/iapsz/${id}/aktualny_stav/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  updateIapszAktualnyStav(item, iapsz_id) {
    const url = `/iapsz/${iapsz_id}/aktualny_stav/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  getIapszDokumenty(id) {
    const url = `/iapsz/${id}/dokumenty/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  updateIapszDokumenty(item, iapsz_id, item_id) {
    const url = `/iapsz/${iapsz_id}/dokumenty/${item_id}/`;
    return session.put(url, item).then(response => response.data);
  }

  deleteIapszDokumentyFile(iapsz_id, item_id, field_name) {
    const url = `/iapsz/${iapsz_id}/dokumenty/${item_id}/delete_file/`;
    return session.delete(url, { params: { field_name: field_name } }).then(response => response.data);
  }

  getIapszPrehladZmien(id) {
    const url = `/iapsz/${id}/history/`;
    return session.get(url, {}).then(response => response.data);
  }

  getIapszRizikaADohlad(id) {
    const url = `/iapsz/${id}/rizika_a_dohlad/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  updateIapszRizikaADohlad(item, iapsz_id) {
    const url = `/iapsz/${iapsz_id}/rizika_a_dohlad/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  getSocialneProgramy(id) {
    const url = `/iapsz/${id}/programy/`;
    return session.get(url, {}).then(response => response.data.results[0]);
  }

  updateSocialneProgramy(item, iapsz_id) {
    const url = `/iapsz/${iapsz_id}/programy/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  getGeneralZavislostiPredForms(sort, search, limit, offset, filter) {
    let url = "";
    if (filter) {
      var filter_url = filter.reduce(this.buildFilterUrl, "");

      url = `/forms/zavislosti_pred_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}${filter_url}`;
    }
    else
      url = `/forms/zavislosti_pred_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;

    return session.get(url, {}).then(response => response.data);
  }

  getGeneralZavislostiPred(id) {
    const url = `/forms/zavislosti_pred/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  updateGeneralZavislostiPred(item, id) {
    const url = `/forms/zavislosti_pred/${id}/`;
    return session.put(url, item).then(response => response.data);
  }

  deleteGeneralZavislostiPred(item) {
    const url = `/forms/zavislosti_pred/${item.id}/`;
    return session.delete(url, {});
  }

  createGeneralZavislostiPred(item) {
    const url = `/forms/zavislosti_pred/`;
    return session.post(url, item).then(response => response.data);
  }

  getGeneralZavislostiPoForms(sort, search, limit, offset, filter) {
    let url = "";
    if (filter) {
      var filter_url = filter.reduce(this.buildFilterUrl, "");

      url = `/forms/zavislosti_po_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}${filter_url}`;
    }
    else
      url = `/forms/zavislosti_po_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;

    return session.get(url, {}).then(response => response.data);
  }

  getGeneralZavislostiPo(id) {
    const url = `/forms/zavislosti_po/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  updateGeneralZavislostiPo(item, id) {
    const url = `/forms/zavislosti_po/${id}/`;
    return session.put(url, item).then(response => response.data);
  }

  deleteGeneralZavislostiPo(item) {
    const url = `/forms/zavislosti_po/${item.id}/`;
    return session.delete(url, {});
  }

  createGeneralZavislostiPo(item) {
    const url = `/forms/zavislosti_po/`;
    return session.post(url, item).then(response => response.data);
  }

  getGeneralSkalyPredForms(sort, search, limit, offset, filter) {
    let url = "";

    if (filter) {
      var filter_url = filter.reduce(this.buildFilterUrl, "");

      url = `/forms/skaly_pred_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}${filter_url}`;
    }
    else
      url = `/forms/skaly_pred_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;

    return session.get(url, {}).then(response => response.data);
  }

  getGeneralSkalyPred(id) {
    const url = `/forms/skaly_pred/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  updateGeneralSkalyPred(item) {
    const url = `/forms/skaly_pred/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  deleteGeneralSkalyPred(item) {
    const url = `/forms/skaly_pred/${item.id}/`;
    return session.delete(url, {});
  }

  createGeneralSkalyPred(item) {
    const url = `/forms/skaly_pred/`;
    return session.post(url, item).then(response => response.data);
  }


  getGeneralSkalyPoForms(sort, search, limit, offset, filter) {
    let url = "";

    if (filter) {
      var filter_url = filter.reduce(this.buildFilterUrl, "");

      url = `/forms/skaly_po_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}${filter_url}`;
    }
    else
      url = `/forms/skaly_po_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;

    return session.get(url, {}).then(response => response.data);
  }

  getGeneralSkalyPo(id) {
    const url = `/forms/skaly_po/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  updateGeneralSkalyPo(item) {
    const url = `/forms/skaly_po/${item.id}/`;
    return session.put(url, item).then(response => response.data);
  }

  deleteGeneralSkalyPo(item) {
    const url = `/forms/skaly_po/${item.id}/`;
    return session.delete(url, {});
  }

  createGeneralSkalyPo(item) {
    const url = `/forms/skaly_po/`;
    return session.post(url, item).then(response => response.data);
  }


  getGeneralTestyForms(sort, search, limit, offset, filter) {
    let url = "";

    if (filter) {
      var filter_url = filter.reduce(this.buildFilterUrl, "");

      url = `/forms/testy_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}${filter_url}`;
    }
    else
      url = `/forms/testy_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;

    return session.get(url, {}).then(response => response.data);
  }


  getGeneralTesty(id) {
    const url = `/forms/testy/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  updateGeneralTesty(item, id) {
    const url = `/forms/testy/${id}/`;
    return session.put(url, item).then(response => response.data);
  }

  deleteGeneralTesty(item) {
    const url = `/forms/testy/${item.id}/`;
    return session.delete(url, {});
  }

  createGeneralTesty(item) {
    const url = `/forms/testy/`;
    return session.post(url, item).then(response => response.data);
  }


  getGeneralSegregovaneKomunityPredForms(sort, search, limit, offset, filter) {
    let url = "";

    if (filter) {
      var filter_url = filter.reduce(this.buildFilterUrl, "");

      url = `/forms/segregovanekomunity_pred_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}${filter_url}`;
    }
    else
      url = `/forms/segregovanekomunity_pred_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;

    return session.get(url, {}).then(response => response.data);
  }

  getGeneralSegregovaneKomunityPred(id) {
    const url = `/forms/segregovanekomunity_pred/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  updateGeneralSegregovaneKomunityPred(item, id) {
    const url = `/forms/segregovanekomunity_pred/${id}/`;
    return session.put(url, item).then(response => response.data);
  }

  deleteGeneralSegregovaneKomunityPred(item) {
    const url = `/forms/segregovanekomunity_pred/${item.id}/`;
    return session.delete(url, {});
  }

  createGeneralSegregovaneKomunityPred(item) {
    const url = `/forms/segregovanekomunity_pred/`;
    return session.post(url, item).then(response => response.data);
  }

  getGeneralSegregovaneKomunityPoForms(sort, search, limit, offset, filter) {
    let url = "";

    if (filter) {
      var filter_url = filter.reduce(this.buildFilterUrl, "");

      url = `/forms/segregovanekomunity_po_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}${filter_url}`;
    }
    else
      url = `/forms/segregovanekomunity_po_list/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;

    return session.get(url, {}).then(response => response.data);
  }

  getGeneralSegregovaneKomunityPo(id) {
    const url = `/forms/segregovanekomunity_po/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  updateGeneralSegregovaneKomunityPo(item, id) {
    const url = `/forms/segregovanekomunity_po/${id}/`;
    return session.put(url, item).then(response => response.data);
  }

  deleteGeneralSegregovaneKomunityPo(item) {
    const url = `/forms/segregovanekomunity_po/${item.id}/`;
    return session.delete(url, {});
  }

  createGeneralSegregovaneKomunityPo(item) {
    const url = `/forms/segregovanekomunity_po/`;
    return session.post(url, item).then(response => response.data);
  }


  getIntegracnePodnikyForms(sort, search, limit, offset, filter) {
    let url = "";
    if (filter) {
      var filter_url = filter.reduce(this.buildFilterUrl, "");

      url = `/prisoner_socialny_podnik/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}${filter_url}`;
    }
    else
      url = `/prisoner_socialny_podnik/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;

    return session.get(url, {}).then(response => response.data);
  }

  createIntegracnePodnikyZaujem(item, ponuka) {
    const url = `/prisoner_socialny_podnik/${item.id}/zaujem/`;
    return session.post(url, { "ponuka": ponuka }).then(response => response.data);
  }

  deleteIntegracnePodnikyZaujem(item) {
    const url = `/prisoner_socialny_podnik/${item.id}/delete_zaujem/`;
    return session.delete(url, {}).then(response => response.data);
  }

  acceptSocialnyPodnikZaujem(item) {
    const url = `/socialny_podnik_zaujem/${item.id}/accept/`;
    return session.put(url, {}).then(response => response.data);
  }

  rejectSocialnyPodnikZaujem(item) {
    const url = `/socialny_podnik_zaujem/${item.id}/reject/`;
    return session.put(url, {}).then(response => response.data);
  }

  // Socialne podniky
  getSocialnyPodnikUsers(sort, search, limit, offset) {
    const url = `/socialny_podnik_user/?search=${search}&ordering=${sort}&limit=${limit}&offset=${offset}`;
    return session.get(url, {}).then(response => response.data);
  }

  searchSocialnyPodnikUsers(v) {
    const url = `/socialny_podnik_user/?search=${v}`;
    return session.get(url, {}).then(response => response.data);
  }

  getSocialnyPodnikUser(id) {
    const url = `/socialny_podnik_user/${id}/`;
    return session.get(url, {}).then(response => response.data);
  }

  deleteSocialnyPodnikUser(user) {
    const url = `/socialny_podnik_user/${user.id}/`;
    return session.delete(url, {});
  }

  createSocialnyPodnikUser(user) {
    const url = `/socialny_podnik_user/`;
    return session.post(url, user).then(response => response.data);
  }

  updateSocialnyPodnikUser(user) {
    const url = `/socialny_podnik_user/${user.id}/`;
    return session.put(url, user).then(response => response.data);
  }

  meSocialnyPodnikUser() {
    const url = `/socialny_podnik_user/me/`;
    return session.get(url, {}).then(response => response.data);
  }

  createInformacieUVTOSFile(item) {
    const url = `/iapsz_informacie_uvtos_files/`;
    return session.post(url, item).then(response => response.data);
  }

  deleteInformacieUVTOSFile(item) {
    const url = `/iapsz_informacie_uvtos_files/${item.id}/`;
    return session.delete(url, {});
  }

  createInformacieUPSVARFile(item) {
    const url = `/iapsz_informacie_upsvar_files/`;
    return session.post(url, item).then(response => response.data);
  }

  deleteInformacieUPSVARFile(item) {
    const url = `/iapsz_informacie_upsvar_files/${item.id}/`;
    return session.delete(url, {});
  }


  toFormData(obj, form, namespace) {
    let fd = form || new FormData();
    let formKey;

    for (let property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property) && obj[property]) {
        if (namespace) {
          formKey = namespace + '[' + property + ']';
        } else {
          formKey = property;
        }

        // if the property is an object, but not a File, use recursivity.
        if (obj[property] instanceof Date) {
          fd.append(formKey, obj[property].toISOString());
        }
        else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
          this.toFormData(obj[property], fd, formKey);
        } else { // if it's a string or a File object
          fd.append(formKey, obj[property]);
        }
      }
    }
    return fd;
  }

  downloadIapszZivotopis(id, iapsz_id) {
    const url = `/iapsz/${iapsz_id}/swot/${id}/zivotopis/`;
    this.downloadItem(url, `iapsz_${id}_zivotopis.pdf`);
    // return session.get(url, {}).then(response => response.data);
  }

  downloadIapszZivotopisDocx(id, iapsz_id) {
    const url = `/iapsz/${iapsz_id}/swot/${id}/zivotopis_docx/`;
    this.downloadItem(url, `iapsz_${id}_zivotopis.docx`);
    // return session.get(url, {}).then(response => response.data);
  }

  downloadIapszAllThree(id, iapsz_id) {
    const url = `/iapsz/${iapsz_id}/swot/${id}/all_three/`;
    this.downloadItem(url, `iapsz_${id}_all_three.pdf`);
    // return session.get(url, {}).then(response => response.data);
  }

  passwordReset(id, iapsz_id) {
    const url = `/iapsz/${iapsz_id}/swot/${id}/password_reset/`;
    return session.put(url, {}).then(response => response.data);
  }

  downloadItem(url, name) {
    session
      .get(url, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
      })
  }
}
